import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import './skeleton'
import { SkeletonPreset } from './skeleton-preset'

/** Deterministic width pattern, indexed by position — never `Math.random()`, so chips stay stable across renders. */
const CHIP_WIDTHS = [96, 72, 120, 64, 88, 104] as const

/** Renders `count` pill-shaped placeholders in a wrapping flex row; width cycles through CHIP_WIDTHS. */
@customElement('schmancy-skeleton-chips')
export class SchmancySkeletonChips extends SkeletonPreset {
	static styles = [
		css`
			:host {
				display: flex;
				flex-wrap: wrap;
				gap: 0.5rem;
			}
			schmancy-skeleton {
				height: 32px;
				border-radius: var(--schmancy-radius-full, calc(infinity * 1px));
				flex-shrink: 0;
			}
		`,
	]

	render() {
		return html`${Array.from(
			{ length: this.count },
			(_, i) => html`<schmancy-skeleton style="width:${CHIP_WIDTHS[i % CHIP_WIDTHS.length]}px"></schmancy-skeleton>`,
		)}`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-skeleton-chips': SchmancySkeletonChips
	}
}
